import '../../css/mk-brand.css';
import {useState, useEffect} from 'react';


function RarityPanel(props) {
  useEffect(() => {
  },);
  // @ts-ignore
  const background = props.background ? 'bg-zinc-800' : '';
  return (
    <div id="collections-rarity-panel" className="m-2">
      <div className="container max-w-6xl">
        <div className={`${background} p-4 rounded-lg`}>
          <div className="flex">
            <h1 className="text-2xl md:text-4xl justify-self-start mt-6">Rarity</h1>
            <div className="container">
              <div className="text-right mt-6 text-xl md:text-3xl">
                <i className="fa-solid fa-star text-brand"/>
                <i className="fa-solid fa-star text-brand"/>
                <i className="fa-solid fa-star text-brand"/>
                <i className="fa-solid fa-star text-brand"/>
                <i className="fa-solid fa-star"/>
              </div>
            </div>
          </div>
          <hr/>
          <p className="text-xl p-4">OG Chefs are created from two base models with <em>400+ traits</em> spanning <em>23 different categories</em>.
            Every OG Chef will have a rarity of 1 to 5 stars. OG Chef rarity will directly impact the amount of CHEF coin farmed.
           Each OG Chef is composed of the following traits: Body, Pants, Clothes, Eyes, Mouth, Glasses, Hair & Hats, Left and Right Hand Items, and metaArms. </p>
        </div>
      </div>
    </div>
  );
}

export default RarityPanel;

